/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Map from 'scripts/models/base/map';
import { EventsList } from './models/events';
import Component from 'can/component/component';
import template from './general-schedule.stache';
import ajax from 'scripts/utils/ajax';
import _ from 'lodash';
import dayjs from 'dayjs';

Component.extend({
    tag: 'general-schedule',
    template: template,
    viewModel: {
        dateGroups: {},
        define: {
            events: {
                Type: EventsList,
                Value: EventsList,
            },
        },
    },
    helpers: {},
    events: {
        inserted: function() {
            let events = [];
            let now = dayjs();
            const incomingDateFormat = 'YYYY-MM-DDTHH:mm:ss';
            const groupDateFormat = 'dddd, MMMM D';
            const timeFormat = 'h:mm';
            const intervalFormat = 'a';

            this.viewModel.attr('data').each((event) => {
                this.viewModel.attr('events').push(event);
            });

            this.viewModel.attr('events').each((event) => {
                let startTime = event.startTime
                    ? dayjs(event.startTime, incomingDateFormat)
                    : false;
                let endTime = event.endTime
                    ? dayjs(event.endTime, incomingDateFormat)
                    : false;

                if (
                    startTime &&
                    endTime &&
                    startTime.isValid() &&
                    endTime.isValid()
                ) {
                    if (!endTime.isBefore(now, 'day')) {
                        events.push({
                            timestamp: startTime.valueOf(),
                            groupDate: startTime.format(groupDateFormat),
                            text: event.text,
                            startTime: startTime.format(timeFormat),
                            startInterval: startTime.format(intervalFormat),
                            endTime: endTime.format(timeFormat),
                            endInterval: endTime.format(intervalFormat),
                        });
                    }
                }
            });

            this.viewModel.attr(
                'dateGroups',
                new Map(
                    _.groupBy(
                        _.orderBy(
                            events,
                            ['timestamp', 'asc'],
                            ['startTime', 'asc'],
                        ),
                        'groupDate',
                    ),
                ),
            );
        },
    },
});
